import http from '@/utils/http';

module.exports = {
  // 判断门店是否已提交申请
  apiGetApplied(storeId) {
    return http
      .get('/workscene/workscene/v1/free_service/applied', { storeId })
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 获取所有服务列表
  apiGetItem() {
    return http
      .get('/workscene/workscene/v1/free_service/get/item/package')
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 提交服务申请
  apiSubmitService(data) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    return http
      .post(
        '/workscene/workscene/v1/free_service/submit',
        JSON.stringify(data),
        headers
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
};
